import {TimelineEntry} from './TimelineEntry';

export class TimelineFinishedEntry extends TimelineEntry {

    constructor(public key: string, public startDate: Date) {
        super(key, 'Finished', startDate, true);
    }

    getColor(): string {
        return 'green';
    }

}
